import React from "react";
import "./index.scss";
import {FontAwesomeIconProps} from "@fortawesome/react-fontawesome";
import {CircularProgress} from "@material-ui/core";

interface Index {
    id?: string;
    label: string;
    onClickListener?: () => void;
    variant?: "filled" | "double-underline" | "notSelected" | "outlined" | "link";
    type?: "submit" | "button";
    icon?: React.ReactElement<FontAwesomeIconProps>;
    iconPos?: "left" | "right";
    isProcess?: boolean;
    disabled?: boolean;
}

export const Button = (props: Index) => {
    const {variant, label, onClickListener, type, icon, iconPos, isProcess, disabled} = props;

    const variantClass = variant || 'filled';
    const iconPosClassName = iconPos ? `button_${iconPos}-icon` : 'button_right-icon';

    return (
        <button className={`button button_${variantClass} ${iconPosClassName} ${disabled ? 'button--disabled' : ''}`}
                id={props.id}
                disabled={isProcess || disabled}
                onClick={onClickListener}
                type={type || "button"}>

            <div className={"button__label"}>
                {isProcess && (
                    <span className={"button__process"}><CircularProgress color="inherit" size={20}/></span>
                )}

                <span className={"button__label__text"}>{label}</span>
            </div>


            {icon && !isProcess && (
                <span className={"button__icon"}>{icon}</span>
            )}
        </button>
    )
};
